import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { STComponent, STColumn, STReq, STRequestOptions, STRes, STPage } from '@delon/abc';
import { _HttpClient } from '@delon/theme';
import { Router } from '@angular/router';
import { format, subDays, differenceInCalendarDays } from 'date-fns';
import { NzMessageService } from 'ng-zorro-antd/message';
import { deepCopy } from '@delon/util';
import { DialogService } from 'icc-common-lib';
import { URLS } from '../../../shared/constant/interface';

@Component({
  selector: 'app-tiktok-account',
  templateUrl: './tiktok-account.component.html',
  styleUrls: ['./tiktok-account.component.less'],
})
export class TiktokAccountComponent implements OnInit {
  constructor(private router: Router, private http: _HttpClient, private dialogService: DialogService, private cdr: ChangeDetectorRef, private message: NzMessageService) {}

static NAME = 'icc-msg-social-account';

  @ViewChild('st', { static: false }) st: STComponent;

  // 获取微信公众号列表的url
  url = URLS.tiktokOfficialAccountStatList.url;
  stData: any[] = [];
  currentIndex = 1;
  pageSize = 10;
  total = 0;
  loading = true;

  isShowInfo = true;

  // 时间选择器选择时间有误
  isRangeError: boolean;
  validateRange = {
    errorKey: '',
    errorList: [
      {
        key: 'max-range-error',
        value: '最大跨度为180天',
      },
      {
        key: 'min-range-error',
        value: '最小跨度为7天',
      },
    ],
  };

  expandForm = true;
  searchTikTokNums: any[] = [];
  searchOptions = {
    channelId: -1,
    start: subDays(new Date(), 31),
    end: subDays(new Date(), 1),
  };

  request = {
    pi: this.currentIndex,
    ps: this.pageSize,
    params: {
      channelId: -1,
      start: null,
      end: null,
    },
  };

  hisSuffixOffset = '';

  columns: STColumn[] = [
    {
      title: '抖音号',
      index: 'tikTokNum',
      className: 'text-center',
      sort: {
        compare: (a, b) => {
          return b.tikTokNum.localeCompare(a.tikTokNum);
        },
      },
    },
    {
      title: '抖音昵称',
      index: 'tikTokName',
      className: 'text-center',
      sort: {
        compare: (a, b) => {
          return b.tikTokName.localeCompare(a.tikTokName);
        },
      },
    },
    {
      title: '粉丝总数',
      index: 'fansTotal',
      className: 'text-center',
      sort: {
        compare: (a, b) => {
          return b.fansTotal - a.fansTotal;
        },
      },
    },
    {
      title: '视频总数',
      index: 'publishedTotal',
      className: 'text-center',
      sort: {
        compare: (a, b) => {
          return b.publishedTotal - a.publishedTotal;
        },
      },
    },
    {
      title: '播放总数',
      index: 'broadcastTotal',
      className: 'text-center',
      sort: {
        compare: (a, b) => {
          return b.broadcastTotal - a.broadcastTotal;
        },
      },
    },
    {
      title: '点赞总数',
      index: 'praiseTotal',
      className: 'text-center',
      sort: {
        compare: (a, b) => {
          return b.praiseTotal - a.praiseTotal;
        },
      },
    },
    {
      title: '分享总数',
      index: 'sharedTotal',
      className: 'text-center',
      sort: {
        compare: (a, b) => {
          return b.sharedTotal - a.sharedTotal;
        },
      },
    },
    {
      title: '评论总数',
      index: 'commentTotal',
      className: 'text-center',
      sort: {
        compare: (a, b) => {
          return b.commentTotal - a.commentTotal;
        },
      },
    },
    {
      title: '主页访问总数',
      index: 'homeVisitTotal',
      className: 'text-center',
      sort: {
        compare: (a, b) => {
          return b.homeVisitTotal - a.homeVisitTotal;
        },
      },
    },
    {
      title: '操作',
      className: 'text-center color',
      buttons: [
        {
          type: 'link',
          text: '分析详情',
          click: (item: any) => {
            this.router.navigate(['/stat/social/tiktok/analyze'], { queryParams: { channelId: item.channelId, tiktokName: item.tikTokName, tiktokNum: item.tikTokNum } });
          },
        },
      ],
    },
  ];

  req: STReq = {
    method: 'POST',
    allInBody: true,
    body: {
      params: {
        ...this.request.params,
      },
    },
  };

  res: STRes = {};

  page: STPage = {};

  ngOnInit(): void {
    this.requestTikTokNums();
    setTimeout(() => {
      this.resetTableList();
    }, 200);
    setTimeout(() => {
      this.isShowInfo = false;
    }, 15000);
  }

  requestTikTokNums() {
    const searchTikTokNums = [{ label: '全部', value: -1 }];
    this.http.post(URLS.officialAccountTikTokNums.url).subscribe(res => {
      if (res.status === 0) {
        res.data.forEach((item, index: number, array) => {
          searchTikTokNums.push({ label: item.tikTokNum, value: item.channelId });
        });
        this.searchTikTokNums = searchTikTokNums;
      }
    });
  }

  getTableList() {
    if (!this.selectDate()) {
      this.resetTableList();
    }
    if (!this.searchOptions.channelId) {
      this.request.params.channelId = -1;
    } else {
      this.request.params.channelId = this.searchOptions.channelId;
    }
    if (this.searchOptions.start !== null) {
      let start = deepCopy(this.searchOptions.start);
      this.request.params.start = format(start, 'yyyyMMdd');
    }
    if (this.searchOptions.end !== null) {
      let end = deepCopy(this.searchOptions.end);
      this.request.params.end = format(end, 'yyyyMMdd');
    }

    this.http.post(URLS.tiktokOfficialAccountStatList.url, this.request).subscribe(
      res => {
        if (res.status === 0) {
          this.stData = res.list;
          this.total = res.total;
          this.cdr.detectChanges();
        }
        this.loading = false;
      },
      error => {
        this.loading = false;
      },
    );
  }

  resetTableList() {
    this.searchOptions = {
      channelId: -1,
      start: subDays(new Date(), 31),
      end: subDays(new Date(), 1),
    };
    this.request.params = deepCopy(this.searchOptions);
    this.getTableList();
  }

  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, new Date()) > -1 || differenceInCalendarDays(current, new Date()) < -1095;
  };

  handleDateChange() {
    if (!this.selectDate()) {
      this.searchOptions.start = subDays(new Date(), 31);
      this.searchOptions.end = subDays(new Date(), 1);
    }
  }

  selectDate() {
    const selectRange = differenceInCalendarDays(this.searchOptions.end, this.searchOptions.start);
    let errorKey = selectRange > 179 ? 'max-range-error' : selectRange < 0 ? 'min-range-error' : '';
    if (errorKey) {
      const filterErrors = this.validateRange.errorList.filter(item => item.key === errorKey);
      if (filterErrors.length) {
        this.dialogService.notification.error('查询条件', filterErrors[0].value);
        this.validateRange.errorKey = filterErrors[0].key;
        this.isRangeError = true;
      }
      return false;
    } else {
      this.isRangeError = false;
      this.validateRange.errorKey = '';
    }
    return true;
  }

  closeInfo() {
    this.isShowInfo = false;
  }

  pageChange() {
    this.request.pi = this.currentIndex;
    this.request.ps = this.pageSize;
    this.getTableList();
  }
}
